import { dates } from "../Config";
import { useAppContext } from "../contexts/AppContext";
import { useAppStore } from "../stores/AppStore";
import type { AvailableFromProps } from "../types/components/AvailableFromProps";
import { DateInfo, DateDifference } from "../utilities/DateUtils";

export const AvailableFrom = ({ date }: AvailableFromProps) => {
	let availableFrom = "Free Delivery For";
	let availableFromDate = "Tomorrow";

	const dateInformation = DateInfo(date);
	let difference = false;
	if (date !== false) {
		difference = DateDifference(date);
	}

	const appData = useAppContext();
	const { peakConfigs: storedPeakConfigs } = useAppStore(({ peakConfigs }) => ({ peakConfigs }));
	const peakConfigs = appData?.peakConfigs || storedPeakConfigs;

	if (dateInformation && difference) {
		if (
			peakConfigs?.CHRISTMAS_HEADER &&
			difference.days === 0 &&
			dates.currentDate > new Date("2025-12-22T22:00:00") &&
			dates.currentDate < new Date("2025-12-23T22:00:00")
		) {
			availableFrom = "";
			availableFromDate = "Arrives in time for Christmas";
		} else if (difference.days === 0) {
			availableFrom = "Free Delivery From";
			availableFromDate = `Tomorrow, ${dateInformation.pretty.short.day} ${dateInformation.pretty.short.date} ${dateInformation.pretty.short.month}`;
		} else if (dateInformation.pretty && dateInformation.pretty.long.month && dateInformation.pretty.long.date) {
			availableFrom = `Free Delivery From`;
			availableFromDate = `${dateInformation.pretty.short.month} ${dateInformation.pretty.short.date}`;
		}
	} else {
		availableFrom = "Out Of Stock";
		availableFromDate = "";
	}

	return (
		<div className="available-from-container">
			<div className={`available-from ${date === false ? "out-of-stock" : "in-stock"}`}>
				{availableFrom} <strong>{availableFromDate}</strong>
			</div>
		</div>
	);
};
